const isValidWebsite = (url = '') => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl || trimmedUrl.includes('@')) return false;

  try {
    // Add protocol if missing for URL constructor
    const urlWithProtocol = /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;

    const { hostname, protocol, username, password } = new URL(urlWithProtocol);

    // Reject if URL contains authentication credentials
    if (username || password) return false;

    // Validate protocol
    if (!['http:', 'https:'].includes(protocol)) return false;

    // Reject commas in hostname (typos like www,google.com)
    if (hostname.includes(',')) return false;

    // Extract domain (remove www. if present)
    const domain = hostname.replace(/^www\./i, '');
    if (!domain) return false;

    // Validate domain structure: must have domain.tld format
    // Both domain and TLD must be at least 2 characters
    const parts = domain.split('.');
    const [last] = parts.slice(-1);
    return parts.length >= 2 && parts.every(Boolean) && last.length >= 2;
  } catch {
    return false;
  }
};

const EMAIL_PATTERN = /^[^\s@.]+(\.[^\s@.]+)*@[^\s@.[\]]+(\.[^\s@.[\]]+)+$/;
const EMAIL_MAX_LENGTH = 254;

const isValidEmail = (email = ''): boolean => {
  const trimmed = email.trim();
  return trimmed.length <= EMAIL_MAX_LENGTH && EMAIL_PATTERN.test(trimmed);
};

// tel: links only need a plausible phone string, not full E.164 parsing.
const isValidPhone = (phone = ''): boolean => {
  const digits = phone.replace(/[\s().+-]/g, '');
  return /^\d{7,15}$/.test(digits);
};

/** Standard campaign / activity UUID string shape (aligned with ai-assistant campaign URL patterns). */
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const isValidUuid = (value?: string | null): boolean => {
  if (value === null || value === undefined) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return UUID_PATTERN.test(trimmed);
};

const isValidUrl = (url = '') => {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return false;

  try {
    const { protocol, username, password } = new URL(trimmedUrl);

    if (username || password) return false;

    return ['http:', 'https:'].includes(protocol);
  } catch {
    return false;
  }
};

export {
  EMAIL_MAX_LENGTH,
  EMAIL_PATTERN,
  isValidEmail,
  isValidPhone,
  isValidUrl,
  isValidUuid,
  isValidWebsite,
  UUID_PATTERN,
};
